import {
  BoxedBatteryIcon,
  BoxedBatteryIcon2024,
  BoxedBedIcon,
  BoxedDiamondIcon,
  BoxedMeditationIcon,
  BoxedReadinessOutlineIcon,
  BoxedSensingIcon,
  BoxedSensorsIcon,
  BoxedTitaniumIcon,
  BoxedWaterDropIcon,
  BoxedWaterResistIcon,
} from '@jouzen/ecom-components';
import type { SVGIconComponent } from 'types/svgr';

export type SlideshowItemIconDataType = Readonly<
  Record<string, SVGIconComponent>
>;

export const SlideshowItemIconData: SlideshowItemIconDataType = {
  sensors_boxed: BoxedSensorsIcon,
  battery_boxed: BoxedBatteryIcon,
  titanium_boxed: BoxedTitaniumIcon,
  water_resist_boxed: BoxedWaterResistIcon,
  battery_boxed_2024: BoxedBatteryIcon2024,
  diamond_boxed: BoxedDiamondIcon,
  sensing_boxed: BoxedSensingIcon,
  water_drop_boxed: BoxedWaterDropIcon,
  meditation_boxed: BoxedMeditationIcon,
  readiness_outline_boxed: BoxedReadinessOutlineIcon,
  bed_boxed: BoxedBedIcon,
};
